import { Center, Group, Loader, MantineNumberSize } from '@mantine/core'

interface LoadingProps {
  size?: MantineNumberSize
  height?: string
}

export function Loading({ size = 'sm', height = '100vh' }: LoadingProps) {
  return (
    <Group
      sx={() => ({
        height,
        justifyContent: 'center',
      })}
    >
      <Center>
        <Loader size={size} />
      </Center>
    </Group>
  )
}
